/**
 * Digital Worker API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface WeightLineRequest {
  clientLineId?: string;
  performedBy?: string;
  mainCategory?: WeightLineRequest.MainCategoryEnum;
  areaTagSystem?: string;
  quantityMetres?: string;
  hoursSpent?: number;
  installedWeight?: number;
  removedWeight?: number;
  changeFollowUpRequired?: boolean;
  description?: string;
  comment?: string;
  selectedCategoryIds?: Array<string>;
}
export namespace WeightLineRequest {
  export const MainCategoryEnum = {
    AdditionalWork: 'ADDITIONAL_WORK',
    WeightChange: 'WEIGHT_CHANGE',
    Other: 'OTHER',
  } as const;
  export type MainCategoryEnum = (typeof MainCategoryEnum)[keyof typeof MainCategoryEnum];
}
